// import { useNavigate } from 'react-router-dom';
import { MapPinIcon, ListBulletIcon, QuestionMarkCircleIcon, BoltIcon } from '@heroicons/react/24/outline';
import { Rule } from '../types';
import { DIMENSION_COLORS } from '../constants';

interface HeaderProps {
  currentDimension: number;
  currentLevel: number;
  rulesCount: number;
  rules: Rule[];
  onHelpClick: () => void;
  onLevelSelectClick: () => void;
}

export function Header({ currentDimension, currentLevel, rulesCount, rules, onHelpClick, onLevelSelectClick }: HeaderProps) {
  // const navigate = useNavigate();

  return (
    <div className={`header dim${currentDimension}`}>
      <div className="title">
        <h1 className={`dim${currentDimension}`}>4D YOU</h1>
        <p><MapPinIcon className="inline-icon" style={{ width: '16px', height: '16px', display: 'inline-block', verticalAlign: 'middle', marginRight: '6px' }} />Reach PURPLE PORTAL • Press 1-4 to Switch</p>
      </div>
      
      <div className="header-stats">
        <div className="stat-item">
          <span className="stat-label">LVL</span>
          <span className={`stat-value dim${currentDimension}`}>{currentLevel}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">DIM</span>
          <span className={`stat-value dim${currentDimension}`}>{currentDimension}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">RULES</span>
          <span className={`stat-value dim${currentDimension}`}>{rulesCount}</span>
        </div>
      </div>

      <div className="header-rules">
        <div className="rules-label-inline">
          <BoltIcon style={{ width: '12px', height: '12px', display: 'inline-block', verticalAlign: 'middle', marginRight: '3px' }} />
          ACTIVE
        </div>
        <div className="rules-list-inline">
          {rules.length === 0 ? (
            <span style={{ color: '#666', fontSize: '9px' }}>No rules...</span>
          ) : (
            rules.map((rule, index) => (
              <span
                key={index}
                className="rule-badge"
                style={{ borderColor: DIMENSION_COLORS[rule.dimension] }}
              >
                {rule.noun} IS {rule.property}
              </span>
            ))
          )}
        </div>
      </div>
      
      <div className="button-container">
        {/* <button className="header-button" onClick={() => navigate('/leveleditor')}>
          <PaintBrushIcon style={{ width: '16px', height: '16px' }} /> EDITOR
        </button> */}
        <button className="header-button" onClick={onLevelSelectClick}>
          <ListBulletIcon style={{ width: '16px', height: '16px' }} /> LEVELS
        </button>
        <button className="header-button" onClick={onHelpClick}>
          <QuestionMarkCircleIcon style={{ width: '16px', height: '16px' }} /> H
        </button>
      </div>
    </div>
  );
}
